module.exports = __webpack_public_path__ + "img/65.status_head_paper.97ec8b08.svg";